import { render, staticRenderFns } from "./whiteList.vue?vue&type=template&id=00dacdf2&scoped=true&"
import script from "./whiteList.vue?vue&type=script&lang=js&"
export * from "./whiteList.vue?vue&type=script&lang=js&"
import style0 from "./whiteList.vue?vue&type=style&index=0&id=00dacdf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dacdf2",
  null
  
)

export default component.exports